import {
  ADD_SPACE_TAG,
  CHECK_ALL_SPACE,
  CHECK_SPACE,
  DELETE_SPACES,
  DELETE_SPACE_TAG,
  FILTER_SPACE,
  SET_LEGAL_CAPACITY,
  SET_SAFE_CAPACITY,
  SET_SPACES,
  SET_TARGET_CAPACITY,
  SpacesAction,
} from "../types";

import { Space } from "../../types";

export const setSpaces = (spaces: Space[]): SpacesAction => {
  return {
    type: SET_SPACES,
    payload: spaces,
  };
};

export const checkSpace = (id: string, selected: boolean): SpacesAction => {
  return {
    type: CHECK_SPACE,
    payload: {
      id: id,
      selected: selected,
    },
  };
};

export const filterSpace = (id: string, filtered: boolean): SpacesAction => {
  return {
    type: FILTER_SPACE,
    payload: {
      id: id,
      filtered: filtered,
    },
  };
};

export const checkAllSpaces = (checked: boolean): SpacesAction => {
  return {
    type: CHECK_ALL_SPACE,
    payload: checked,
  };
};

export const deleteSpaces = (): SpacesAction => {
  return {
    type: DELETE_SPACES,
  };
};

export const addSpaceTag = (id: string, tag: string): SpacesAction => {
  return {
    type: ADD_SPACE_TAG,
    payload: {
      id: id,
      tag: tag,
    },
  };
};

export const deleteSpaceTag = (id: string, tag: string): SpacesAction => {
  return {
    type: DELETE_SPACE_TAG,
    payload: {
      id: id,
      tag: tag,
    },
  };
};

export const setSafeCapacity = (id: string, capacity: number): SpacesAction => {
  return {
    type: SET_SAFE_CAPACITY,
    payload: {
      id: id,
      capacity: capacity,
    },
  };
};

export const setTargetCapacity = (
  id: string,
  capacity: number
): SpacesAction => {
  return {
    type: SET_TARGET_CAPACITY,
    payload: {
      id: id,
      capacity: capacity,
    },
  };
};

export const setLegalCapacity = (
  id: string,
  capacity: number
): SpacesAction => {
  return {
    type: SET_LEGAL_CAPACITY,
    payload: {
      id: id,
      capacity: capacity,
    },
  };
};
